module.exports = __webpack_public_path__ + "newWebTMS/img/mssymbol.319d9b9a.svg";